
function PageLoader() {
  return (
    <div className="h-screen w-full z-[1200] flex items-center justify-center">
      {/* <div class="animate-pulse w-28"></div> */}
      <div className="loader3 animate-pulse">
        <img src={'/img/starrik-icons/logo-1-transparent.png'} className="w-full" alt="Starrik Logo"/>
      </div>
    </div>
  );
}

export default PageLoader;
